import React from 'react';

const canWeHelpPluginHeader = () => <span className="aa-SourceHeaderTitle">Can we help</span>;
const canWeHelpPluginItem = ({ item }: any) => (
  <a href={item.url as string} target="_blank" rel="noopener noreferrer">
    {item.label as string}
  </a>
);

export function createCanWeHelpPlugin() {
  return {
    getSources() {
      return [
        {
          sourceId: 'canWeHelpPlugin',
          getItems() {
            return [
              { label: 'Inspire Me', url: '/jsp/contenthub/uk/home.jsp' },
              { label: 'Help & FAQs', url: '/customer-services' },
            ];
          },
          templates: {
            header: canWeHelpPluginHeader,
            item: canWeHelpPluginItem,
          },
        },
      ];
    },
  };
}
